import { IconButton, Tooltip, CircularProgress } from '@mui/material'
import RefreshIcon from '@mui/icons-material/Refresh'

export interface PageRefreshButtonProps {
  onRefresh: () => void
  loading?: boolean
  disabled?: boolean
  title?: string
  size?: 'small' | 'medium' | 'large'
}

/** Manual reload control for admin list/detail pages backed by React Query. */
export default function PageRefreshButton({
  onRefresh,
  loading = false,
  disabled = false,
  title = 'Refresh',
  size = 'small',
}: PageRefreshButtonProps) {
  return (
    <Tooltip title={title}>
      <span>
        <IconButton onClick={onRefresh} disabled={disabled || loading} size={size}>
          {loading ? <CircularProgress size={20} /> : <RefreshIcon />}
        </IconButton>
      </span>
    </Tooltip>
  )
}
